import { Box, Text, Flex, Stack, For } from "@chakra-ui/react";
import Advertising from '@/components/Advertising';
import Categories from '@/components/Categories';
import Readmore from '@/components/Readmore';

export default function Lateral({ ads, showLateralExtras = true }) {
  return (
    <Stack gap="4">
      <For each={ads}>
        {(item, index) => (
          <Box key={index}>
            <Advertising ads={item} />
          </Box>
        )}
      </For>

      { showLateralExtras === true && (
        <Box>
          <Readmore />
        </Box>
      )}

      { showLateralExtras === true && (
        <Box>
          <Categories />
        </Box>
      )}
    </Stack>
  )
}
